import React from "react";
import { StyledInputField, StyledInputFieldContainer, StyledInputFieldLabel, StyledChipContainer, StyledChip, ArrowInMultiSelect } from "./InputFieldStyle";
import { getLanguageValueById, getPreferenceValueById } from "src/consumer/helpers/profilePageHelper";
import upArrowWithBg from "src/assets/up_arrow_with_bg.png";


export const InputField = (props) => {
    const { label } = props;
    return (
        <form>
            <StyledInputFieldContainer>
                <StyledInputFieldLabel>{label}</StyledInputFieldLabel>
                {getInputComponent(props)}
            </StyledInputFieldContainer>
        </form>
    );
}

const getInputComponent = (props) => {
    const { profile, id, handleOnChange, handleOnClick, setupData, displayValue, disabled, isClosed } = props;
    switch (id) {

        case 'contentPreferences': return (
            <StyledChipContainer
                disabled={disabled}
                onClick={(e) => { if (!disabled) { handleOnClick(e) } }}>
                {profile[id]?.value?.map((valueId) =>
                    <StyledChip
                        disabled={disabled}
                        label={getPreferenceValueById(setupData, valueId)}
                        key={valueId}
                        size="large"
                        variant={disabled ? 'outlined' : 'filled'} />)}
                {!disabled && <ArrowInMultiSelect src={upArrowWithBg} isClosed={isClosed} />}
            </StyledChipContainer>);

        case 'contentLanguages': return (
            <StyledChipContainer
                disabled={disabled}
                onClick={(e) => { if (!disabled) { handleOnClick(e) } }}>
                {profile[id]?.value?.map((valueId) =>
                    <StyledChip
                        disabled={disabled}
                        label={getLanguageValueById(setupData, valueId)}
                        key={valueId}
                        size="large"
                        variant={disabled ? 'outlined' : 'filled'} />)}
                {!disabled && <ArrowInMultiSelect src={upArrowWithBg} isClosed={isClosed} />}
            </StyledChipContainer>);

        case 'gender': return (
            <StyledInputField
                disabled={disabled}
                type={"text"}
                value={displayValue || profile[id].value}
                isValid={profile[id].isValid}
                onClick={handleOnClick} />);

        default: return (
            <StyledInputField
                disabled={disabled}
                type={"text"}
                value={displayValue || profile[id].value}
                onChange={(e) => { handleOnChange(e.target.value, id) }}
                isValid={profile[id].isValid}
                onClick={handleOnClick} />);
    }
}

